import styles from './mainPage.module.scss'
import { RequestBody } from "./requestBody/requestBody";
import { ResponseBody } from "./responseBody/responseBody";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { MainHeaderItem } from "./mainHeaderItem/mainHeaderItem";
import { ScenarioMainHeader } from "./scenarioMainHeader/scenarioMainHeader";
import { TestPlanMainHeader } from "./testPlanMainHeader/testPlanMainHeader";
import { IncomingBody } from "./incomingBody/incomingBody";
import { IncomingMainHeader } from "./incomingMainHeader/incomingMainHeader";
import { TemplateView } from "./templateView/templateView";
import { SubHeader } from "./subHeader/subHeader";

export const MainPage = () => {

  const { selectedTestCase, selectedTestCaseTemplate, executeResponse} = useSelector((state: RootState) => state.testCaseTemplateSlice);
  const selectedScenario = useSelector((state: RootState) => state.scenarioSlice.selectedScenario);
  const selectedTestPlan = useSelector((state: RootState) => state.testPlanSlice.selectedTestPlan);
  const { selectedTestCaseIncoming, selectedTestCaseIncomingHistory } = useSelector((state: RootState) => state.testCaseIncomingSlice);

  return (
    <div className={styles.container}>
      {!selectedScenario.id && !selectedTestPlan.id && !!selectedTestCase.id && (
        <MainHeaderItem testCaseTemplate={selectedTestCaseTemplate}
                        testCase={selectedTestCase}
                        executeResponse={executeResponse}
                        selected={true}/>
      )}
      {!!selectedScenario.id && (
        <ScenarioMainHeader/>
      )}
      {!!selectedTestPlan.id && (
        <TestPlanMainHeader/>
      )}
      {!!selectedTestCaseIncoming.id && (
        <IncomingMainHeader />
      )}
      {!!selectedTestCase.id && (<SubHeader />)}
      <div className={styles.bodyContainer}>
        {(!!selectedTestCase.id || !!selectedScenario.id || !!selectedTestPlan.id) && (
          <>
            <RequestBody/>
            <ResponseBody/>
          </>
        )}
        {(!!selectedTestCaseIncoming.id && !!selectedTestCaseIncomingHistory.id) && (
          <>
            <IncomingBody />
            <IncomingBody isResponse={true} />
          </>
        )}
        {(!selectedTestCase.id && !!selectedTestCaseTemplate.id) && (<TemplateView />)}
      </div>
    </div>
  )
}